export default __webpack_public_path__ + "static/jsarson-07f04002a0dbe6b5c23a59c261983526.jpg";